import script from "./PreviewTwilio.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreviewTwilio.vue?vue&type=script&setup=true&lang=ts"

import "./PreviewTwilio.vue?vue&type=style&index=0&id=9170b448&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9170b448"]])

export default __exports__